export default __webpack_public_path__ + "static/media/q3_step5.026b5267.png";